import { createSelector } from 'reselect';
import {
  isWeekly,
  isSubsidizedProduct,
  getDiscountPercent,
} from '@shopDetails/utils/discounts';
import { FAVORITES_DISHES_SECTION_ID } from '@shopDetails/constants';
import getMenuWithDiscounts from './getMenuWithDiscounts';
import getGlobalDiscountsWeekly from './getGlobalDiscountsWeekly';

const MAX_ITEMS = 20;

const getProductsWithDiscount = (sections, discountFromShop) =>
  sections
    .reduce((acc, section) => {
      const { products, id } = section;
      if (products.length && id !== FAVORITES_DISHES_SECTION_ID) {
        acc.push(
          ...products.filter(
            product => isWeekly(product) || isSubsidizedProduct(product),
          ),
        );
      }
      return acc;
    }, [])
    .filter(
      (element, idx, arr) =>
        arr.findIndex(item => item.id === element.id) === idx,
    )
    .sort((productA, productB) => {
      const discountA = getDiscountPercent(productA, discountFromShop);
      const discountB = getDiscountPercent(productB, discountFromShop);
      if (discountA < discountB) return 1;
      if (discountA > discountB) return -1;
      return 0;
    })
    .slice(0, MAX_ITEMS);

export const getDiscountsProducts = createSelector(
  getMenuWithDiscounts,
  getGlobalDiscountsWeekly,
  (menu, weeklyDiscount) => {
    if (menu) {
      const { sections } = menu;
      if (sections.length) {
        return getProductsWithDiscount(sections, weeklyDiscount?.amount);
      }
    }
    return [];
  },
);
